import classNames from 'classnames'
import React, { HTMLAttributes } from 'react'

import { HTMLString } from '~/types/strapi'

interface Properties extends HTMLAttributes<HTMLBaseElement> {
  html: HTMLString
  Tag?: React.ElementType
  balance?: boolean
}

const Title: React.FC<Properties> = ({
  html,
  Tag = 'h2',
  className,
  balance = true,
  ...rest
}) => {
  if (!html) return false

  const filteredHtml = html.replaceAll(
    /<p[^>]*>(.*?)<\/p>/gs,
    '<span>$1</span>'
  )

  return (
    <Tag
      {...rest}
      dangerouslySetInnerHTML={{ __html: filteredHtml }}
      className={classNames(
        'block-title inline-flex flex-col [&>span]:inline-block',
        balance && 'text-balance',
        className
      )}
    />
  )
}

export default Title
